export const NOTIFICATION_EVENT_TYPE = {
  /** 创建事项 */
  CREATE_ITEM: 'createItem',
  /** 删除事项 */
  DELETE_ITEM: 'deleteItem',
  /** 修改负责人 */
  MODIFY_OWNER: 'modifyOwner',
  /** 更改状态 */
  MODIFY_STATUS: 'modifyStatus',
  /** 更新事项 */
  UPDATE_ITEM: 'updateItem',
  /** 审批事项 */
  APPROVE_ITEM: 'approveItem',
  /** 评论事项 */
  ADD_COMMENT: 'addComment',
  /** 更新事项评论 */
  UPDATE_COMMENT: 'updateComment',
  /** 删除事项评论 */
  DELETE_COMMENT: 'deleteComment',
} as const;

export const NOTIFICATION_METHOD = {
  /** 站内信 */
  INTERNAL: 'internal',
  /** 邮件 */
  EMAIL: 'email',
} as const;

// 非one下通知方式
export const NOTIFICATIONS_NOT_ONE = [
  {
    value: NOTIFICATION_METHOD.INTERNAL,
    label: 'notificationScheme.method.internal',
  },
  {
    value: NOTIFICATION_METHOD.EMAIL,
    label: 'notificationScheme.method.email',
  },
];

export const NOTIFICATION_TYPE = {
  /** 角色 */
  WORKSPACE_ROLE: 'workspaceRole',
  /** 用户 */
  USER: 'user',
  /** 字段 */
  USER_FIELD: 'field',
  /** 用户组 */
  USER_GROUP: 'group',
};
